import {
  LOAD_VIEW3,
  LOAD_VIEW3_SUCCESS,
  SAVE_VIEW3,
  SET_QUERYPARMAS,
} from "../constants";

export const loadView3 = ({ url, queryParams }) => {
  return {
    type: LOAD_VIEW3,
    url,
    queryParams,
  };
};

export const saveView3 = ({ id, key, value, data }) => {
  return {
    type: SAVE_VIEW3,
    id,
    key,
    value,
    data,
  };
};

export const loadView3Success = ({
  configuration,
  nodes,
  rootId,
  templateId,
  effects,
  formData,
}) => {
  return {
    type: LOAD_VIEW3_SUCCESS,
    nodes,
    rootId,
    templateId,
    effects,
    formData,
    configuration,
  };
};

export const setQueryParams3 = ({ queryParams }) => {
  return {
    type: SET_QUERYPARMAS,
    queryParams,
  };
};
